import {inject, Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {BaseInterface} from '../../interface/base.interface';
import {Profile} from '../../interface/profile/profile.interface';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private env = environment.baseUrl;
  private baseService  = inject(BaseService)

  public getTabs(): Observable<any> {
    return this.baseService.getBaseInfo(`${this.env}/service/webapi/v1/tabs`);
  }

  public getBaseInfoProfile():Observable<BaseInterface<Profile>>{
    return this.baseService.getBaseInfo(`${environment.nfId}/v1.0/person/self`)
  }
}
